module.exports = __webpack_public_path__ + "static/media/green-tick-filled.4e9a0b2a.svg";